import { render } from "./FormPostComponent.vue?vue&type=template&id=7b0e256e"
import script from "./FormPostComponent.vue?vue&type=script&lang=js"
export * from "./FormPostComponent.vue?vue&type=script&lang=js"

import "./FormPostComponent.vue?vue&type=style&index=0&id=7b0e256e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__